
import { Fragment } from 'vue-frag'
import { CurrentView } from '~/store/building/-constants'

export default {
  name: 'OrganismProjectUI',
  components: { Fragment },
  computed: {
    isFloorView() {
      return this.$store.state.building.currentView === CurrentView.FLOOR
    },
    generalConfig() {
      return this.$store.state.base.meta.generalConfig
    },
    hasMatterport() {
      return this.generalConfig.matterportEnabled
    },
    shouldNotInitiate() {
      const {path} = this.$route;
      return this.hasMatterport && path.includes('/space/')
    }
  }
}
